import { LoginModel } from './entities/LoginModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/take';

import { SessionModel } from './entities/sessionModel';
import { UserModel } from './../shared/model/userModel';
import { environment } from './../../environments/environment';
import { AbstractSessionService } from './abstract-session.service';
import { LoginAction, IdleAction, LogoutAction } from '../appState/app.actions';
import { AppState } from '../appState/appStateStore.module';
import { map } from 'rxjs/operator/map';
import { QuestionModel } from './entities/QuestionModel';


@Injectable()
export class SessionService implements AbstractSessionService {
  timer: Observable<number>;
  timerSubscription: Subscription;

  constructor(private store: Store<AppState>, private http: HttpClient, private idle: Idle, private keepalive: Keepalive) {}

  login(user: UserModel): Observable<boolean> {
    return this.logonRequest(user)
            .map( (loginModel: LoginModel) => {
                if (!loginModel && !loginModel.token) {
                  return false;
                }
                let newIdleState = !loginModel.pwdNeedsChange.PasswordNeedsChange && !loginModel.pinRequired;
                this.store.dispatch( new LoginAction( {
                    passwordNeedsChange : loginModel.pwdNeedsChange,
                    token: loginModel.token,
                    username: user.username,
                    pinRequired: loginModel.pinRequired,
                    isIdleRunning: newIdleState
                }));

                if (newIdleState){
                  this.initIdle();
                }
                return true;
          });
  }

  getSession(): Promise<SessionModel> {
    return new Promise<SessionModel>((resolve, reject) => {
      this.store.take(1).subscribe(s => {
        if (!s.app.session.user || !s.app.session.token) {
          reject('Keine gültige Anmeldung!');
        } else {
          resolve(s.app.session);
        }
      });
    });
  }

  private logonRequest(user: any): Observable<LoginModel> {
    const url = environment.apiBaseUrl + 'logon';
    const logonData = JSON.stringify(user);
    const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    return this.http.post<LoginModel>(url, logonData, { headers: headers });
  }

  private timeout(idletime: number) {
    this.store.dispatch( new IdleAction( idletime ));

    this.store.filter(s => s.app.session.sessionTimeout <= 0 && s.app.session.loggedIn)
              .subscribe(s => this.logout());
  }

  logout() {
    this.idle.ngOnDestroy(); // includes this.idle.stop() and this.clearInterrupts() both.
    this.getSession()
      .then(s => this.doServerLogout(s))
      .catch(() => this.store.dispatch( new LogoutAction()));
  }

  doServerLogout(session: SessionModel) {
    const url = environment.apiBaseUrl + 'logon/logout';
    const headers = new HttpHeaders()
        .set('authorization', 'Bearer ' + session.token )
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    this.http
          .post(url, {} , { headers: headers, responseType: 'text' })
          .finally( () => this.store.dispatch(  new LogoutAction()))
          .subscribe();
  }

  initIdle() {
    if (this.idle.isRunning()){
      return;
    }
    if (!this.store.select(s => s.app.session.loggedIn)){
      return;
    }

    this.idle.setIdle(60);
    this.idle.setTimeout(540);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.timeout(10);

    this.idle.onIdleEnd.subscribe(() => this.timeout(10));
    this.idle.onTimeout.subscribe(() => {
      this.logout();
    });

    // this.idle.onIdleStart.subscribe(() => this.idlestate = 'You\'ve gone idle!');
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      if (countdown % 60 === 0) { this.timeout( countdown / 60); }
    });

    //  Server Token aktualisieren
    this.keepalive.interval(59);
    this.keepalive.onPing.subscribe(() => this.refreshToken());
    this.idle.watch();
  }

  refreshToken() {
    this.getSession()
        .then(s => this.doServerRefresh(s));
  }

  doServerRefresh(session: SessionModel) {
    const url = environment.apiBaseUrl + 'logon/refresh';
    const headers = new HttpHeaders()
        .set('authorization', 'Bearer ' + session.token )
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    this.http.post(url, {} , { headers: headers }).subscribe( d => { });
  }

  getQuestion(username: string): Observable<QuestionModel> {
    const url = environment.apiBaseUrl + 'logon/getQuestion';
    const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    var userModel = { Username: username };
    return this.http.post<QuestionModel>(url, userModel, { headers: headers });
  }

  getVersion(): Observable<string> {
    const url = environment.apiBaseUrl + 'logon/getVersion';
    const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Accept', 'application/json');

    return this.http.post<string>(url, {}, { headers: headers });
  }

  activateIdle(): void  {
    this.initIdle();
  }
}



// WEBPACK FOOTER //
// ./src/app/session/session.service.ts